import {useMemo} from "react";
import {List} from "@mui/material";
import {InvitationsController} from "./Invitations.tsx";
import InvitationItem from "./InvitationItem.tsx";

interface InvitationsListProps {
    readonly invitationsController: InvitationsController;
}

export default function InvitationsList({invitationsController}: InvitationsListProps) {

    return useMemo(() => {
        return <List>
            {
                invitationsController?.invitations
                    ?.map(invitation =>
                        <InvitationItem
                            key={invitation.id}
                            invitationsController={invitationsController}
                            invitation={invitation}
                        />
                    )
            }
        </List>
    }, [invitationsController])
}